import { render, staticRenderFns } from "./UnboxBoxElement.vue?vue&type=template&id=562cacda&scoped=true"
import script from "./UnboxBoxElement.vue?vue&type=script&lang=js"
export * from "./UnboxBoxElement.vue?vue&type=script&lang=js"
import style0 from "./UnboxBoxElement.vue?vue&type=style&index=0&id=562cacda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562cacda",
  null
  
)

export default component.exports